<template>
  <router-view />
</template>

<script setup>
import {nextTick, onMounted, onBeforeMount} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import ZhiService from "@/core/services/ZhiService";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import request from "sync-request";
import axios from "axios";

import { debounce } from "lodash";
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 100)
    super(callback);
  }
}

const store = useStore();
const router = useRouter();

async function init(){
  let res = await axios.post(process.env.VUE_APP_API_URL+"/api/corp/init",{
    'Content-Type': 'application/json;charset=UTF-8'
  })
  if(res && res.status == 200){
    if(res['data']['flag'] == 'yes' && res['data']['data']){
      store.commit(Mutations.SET_CORP_INFO, res['data']['data']);
      if(!ZhiService.checkDirectAccess(window.location.pathname)){
        if(!ZhiService.authVerify()){
          store.dispatch(Actions.LOGOUT).then(() => router.push({ name: "sign-in" }));
        }else{
          store.commit(Mutations.SET_USER, ZhiService.getAccountInfo());
          ZhiService.initAccountInfo();
        }
      }
    }
  }else if(res.status == 403){
    router.push({ name: "ai-forbidden" });
  }
}
onMounted(() => {
  console.log('begin to auth verify');
  let res = request('POST', process.env.VUE_APP_API_URL+'/api/corp/init', {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
  });
  if(res && res['statusCode'] == 200){
    let data = JSON.parse(res.getBody('utf8'));
    if(data['flag'] && data['flag'] == 'yes'){
      if(data['data']){
        store.commit(Mutations.SET_CORP_INFO, data['data']);
        if(!ZhiService.checkDirectAccess(window.location.pathname)){
          if(!ZhiService.authVerify()){
            store.dispatch(Actions.LOGOUT).then(() => router.push({ name: "sign-in" }));
          }else{
            store.commit(Mutations.SET_USER, ZhiService.getAccountInfo());
            ZhiService.initAccountInfo();
          }
        }
      }
    }
  }else if(res['statusCode'] == 403){
    router.push({ name: "ai-forbidden" });
  }
});
</script>

<style lang="scss">
@import "~sweetalert2/dist/sweetalert2.css";
@import "~bootstrap/dist/css/bootstrap.min.css";
@import "~element-plus/dist/index.css";
@import "~viewerjs/dist/viewer.css";

@import "zhivue/assets/fontawesome/css/all.css";
@import "zhivue/assets/sass/zhi/theme.scss";
@import "zhivue/assets/sass/zhi/common.scss";

body{
  margin: 0px;
  padding: 0px;
}
</style>
